import { Headers } from '@egw/components'
import { AccountHoldings } from '@egw/features-holdings'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const InvestmentsAccountHoldingsPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.investment.title')} />
      <AccountHoldings />
    </Layout>
  )
}
